import React from "react";
import { TouchableOpacity, View } from "react-native";

const CheckBoxCustom: React.FC<{ isChecked: boolean; onToggle: (checked: boolean) => void }> = ({
    isChecked,
    onToggle
  }) => (
    <TouchableOpacity
      onPress={() => onToggle(!isChecked)}
      style={{
        width: 20,
        height: 20,
        borderRadius: 4,
        borderWidth: 2,
        borderColor: '#ccc',
        backgroundColor: isChecked ? '#96ce00' : 'transparent',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {isChecked && (
        <View
          style={{
            width: 10,
            height: 10,
            backgroundColor: '#96ce00',
            borderRadius: 2,
          }}
        />
      )}
    </TouchableOpacity>
  )

  export default CheckBoxCustom